import { useSelector } from 'react-redux';

import { User } from 'models/User';

interface AuthContextResult {
  user: User;
  hasPermission: (permissionCode: string) => boolean;
}

export const useAuthContext = (): AuthContextResult => {
  const user = useSelector((state: any) => state.auth) as User;

  const hasPermission = (permissionCode: string): boolean =>
    user.permissions.some((p) => p.code === permissionCode);

  return { user, hasPermission };
};
